import { Link } from "react-router-dom";
import HeroCircles from "../../../assets/images/hero-circles.svg";

const HeroTests = () => {
  function InfiniteTextSlider() {
    return (
      <div className="overflow-hidden flex items-center mt-10">
        <div className="w-full flex items-center justify-between relative z-[100]">
          <span className="text-sm font-rokh font-[500] text-nowrap px-3">
            آزمـــایش خون
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3">
            آزمـــایش ادرار
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3">
            آزمـــایش مدفوع
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش بررسی کلیه
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش بررسی کبد
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            چـــک‌آپ
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش خون
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش ادرار
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش مدفوع
          </span>
          <span className="text-sm font-rokh font-[500] text-nowrap px-3 hidden lg:flex">
            آزمـــایش بررسی کلیه
          </span>
        </div>
      </div>
    );
  }

  return (
    <Link
      to="/test-registration"
      className="flex-1 block relative bg-pr_purple rounded-xl overflow-hidden px-5 pt-10 pb-2 lg:pb-2 lg:p-14"
    >
      <img
        src={HeroCircles}
        className="absolute -left-52 top-20 w-4/6 rotate-90 animate-pulse z-[0]"
      />
      <h1 className="font-rokh text-[25px] lg:text-4xl font-[900] text-center">
        پلتفرم تفسیر آزمایش بادی‌بان
      </h1>
      <p className="font-rokh font-[700] text-base lg:text-xl text-center max-w-xs lg:max-w-xl mt-2 mx-auto">
        اینجا آزمایشت رو وارد کن و با خوندن تفسیر کاملش، مترجم زبان بدنت باش!
      </p>

      <h6 className="w-[200px] mx-auto bg-pr_purple_dark rounded-2xl px-8 pt-4 pb-3 mt-10 z-[100] relative shadow-xl font-[900] font-rokh text-white flex items-center justify-center">
        شروع تحلیل آزمایش
      </h6>
      {InfiniteTextSlider()}

      {/* <SwiperSlider
        spaceBetween={10}
        slidesPerView={3}
        responsiveSlidesPerView={1.1}
        autoplay
        speed={100}
        classes="mt-10"
      >
        {tests.map((test: any) => (
          <SwiperSlide key={test.en_title} className="pt-20 -mt-20 rounded-xl">
            <div
              className={`relative flex-1 bg-white flex items-center py-4 px-3 rounded-xl`}
            >
              <img
                alt={test.fa_title}
                src={test.icon}
                className="mx-auto w-[50px] lg:w-[70px] h-[50px] lg:h-[70px]"
              />
              <div className="flex-1 flex flex-col items-start justify-center mr-3">
                <h5 className="font-rokh font-[700] text-center lg:text-lg">
                  {test.fa_title}
                </h5>
                <p className="text-right text-sm font-rokh font-[700]">
                  {test.info}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </SwiperSlider> */}
    </Link>
  );
};

export default HeroTests;
